export const SECRETARIAT_ROLE_APPROVE_ID = 1
export const SECRETARIAT_ROLE_DECLINE_ID = 2
export const SECRETARIAT_ROLE_CHANGE_ID = 3
export const ADD_CO_PROPOSER_NOTIFICATION_TYPE_ID = 4
export const REMOVE_CO_PROPOSER_NOTIFICATION_TYPE_ID = 5
